import React from 'react';

function getYouTubeEmbedUrl(url) {
  const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
}

export const VideoEmbed = ({ videoUrl, videoType, title }) => {
  if (!videoUrl) return null;

  if (videoType === 'youtube') {
    const embedUrl = getYouTubeEmbedUrl(videoUrl);
    if (!embedUrl) return null;
    return (
      <div className="aspect-video w-full rounded-sm overflow-hidden border border-borders" data-testid="module-video-embed">
        <iframe
          src={embedUrl}
          title={title}
          className="w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <video controls className="w-full rounded-sm border border-borders" data-testid="module-video-embed">
      <source src={videoUrl} />
      Your browser does not support the video tag.
    </video>
  );
};
